import React from 'react';

import ReconciliationPageComponent from '../../../features/BackOffice/ReconciliationPageComponent';

const Reconciliation = () => {
  return <ReconciliationPageComponent />;
};

export default Reconciliation;
